<template>
	<div class="match">
		<div class="wrapper">
			<div class="match_row">
				<tournaments type="all"></tournaments>
				
				<div class="match_right">
					<div class="team">
						<div class="team_main">
							<div class="team_image">
								<img :src="$hostname + image" alt="">
							</div>
							<div class="team_name">{{ name }}</div>
						</div>
						
						<div class="tab">
							<div class="tab_header">
								<a href="#block-2" class="active">Результаты</a>
								<a href="#block-3" v-if="this.players.length">Состав</a>
								<a href="#block-4">Календарь</a>
							</div>
							
							<div class="tab_content">
								<div class="tab_block active" id="block-2">
									<array-matches :matches="resultsMatches"></array-matches>
									
									<div v-if="loading" class="match-loading info-text"></div>
								</div>
								<div id="block-3" class="tab_block">
									<div class="player">
										<div class="player_heading">
											<div class="player_row">
												<div class="player_col">#</div>
												<div class="player_col">Имя</div>
												<div class="player_col">Возраст</div>
												<div class="player_col">Рост</div>
												<div class="player_col">Вес</div>
												<div class="player_col">Игры</div>
												<div class="player_col">Голы</div>
											</div>
										</div>
									</div>
									
									<div class="player_head" v-if="defender.length">Защитник</div>
									<div class="player_body">
										<player v-for="player in defender" :key="player.id" :player="player"></player>
									</div>
									
									<div class="player_head" v-if="midfielder.length">Полузащитник</div>
									<div class="player_body">
										<player v-for="player in midfielder" :key="player.id" :player="player"></player>
									</div>
									
									<div class="player_head" v-if="forward.length">Нападающий</div>
									<div class="player_body">
										<player v-for="player in forward" :key="player.id" :player="player"></player>
									</div>
									
									<div class="player_head" v-if="center.length">Центровой</div>
									<div class="player_body">
										<player v-for="player in center" :key="player.id" :player="player"></player>
									</div>
									
									<div class="player_head" v-if="smallForward.length">Лёгкий форвард</div>
									<div class="player_body">
										<player v-for="player in smallForward" :key="player.id" :player="player"></player>
									</div>
									
									<div class="player_head" v-if="pointGuard.length">Разыгрывающий защитник</div>
									<div class="player_body">
										<player v-for="player in pointGuard" :key="player.id" :player="player"></player>
									</div>
									
									<div class="player_head" v-if="powerForward.length">Тяжёлый форвард</div>
									<div class="player_body">
										<player v-for="player in powerForward" :key="player.id" :player="player"></player>
									</div>
									
									<div class="player_head" v-if="shootingGuard.length">Атакующий защитник</div>
									<div class="player_body">
										<player v-for="player in shootingGuard" :key="player.id" :player="player"></player>
									</div>
									
									<div class="player_head" v-if="keeper.length">Вратарь</div>
									<div class="player_body">
										<player v-for="player in keeper" :key="player.id" :player="player"></player>
									</div>
									
									<div class="player_head" v-if="coach.length">Тренер</div>
									<div class="player_body">
										<player v-for="player in coach" :key="player.id" :player="player"></player>
									</div>
								</div>
								<div id="block-4" class="tab_block">
									<matches :show-header="false" :list="finishedMatches"></matches>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import _ from 'underscore';
	
	import Tournaments from "../components/Tournaments/Tournaments";
	import Player from "../components/Player/Player";
	import Matches from "../components/Match/Matches";
	import ArrayMatches from "../components/Match/ArrayMatches";
	
	export default {
		components: {
			Tournaments,
			Player,
			Matches,
			ArrayMatches
		},
		
		data() {
			return {
				id: 0,
				image: '',
				name: '',
				players: [],
				resultsMatches: [],
				finishedMatches: {},
				page: 1,
				loading: true,
				activeLoading: false
			}
		},
		
		computed: {
			defender() {
				return this.players.filter((item) => {
					return item.role === 'defender' || item.role === 'guard' || item.role === 'defenceman';
				});
			},
			center() {
				return this.players.filter((item) => {
					return item.role === 'center';
				});
			},
			smallForward() {
				return this.players.filter((item) => {
					return item.role === 'small forward';
				});
			},
			pointGuard() {
				return this.players.filter((item) => {
					return item.role === 'point guard';
				});
			},
			powerForward() {
				return this.players.filter((item) => {
					return item.role === 'power forward';
				});
			},
			shootingGuard() {
				return this.players.filter((item) => {
					return item.role === 'shooting guard';
				});
			},
			midfielder() {
				return this.players.filter((item) => {
					return item.role === 'midfielder';
				});
			},
			forward() {
				return this.players.filter((item) => {
					return item.role === 'forward';
				});
			},
			keeper() {
				return this.players.filter((item) => {
					return item.role === 'keeper' || item.role === 'goaltender';
				});
			},
			coach() {
				return this.players.filter((item) => {
					return item.role === null;
				});
			},
		},
		
		created() {
			this.axios.get('/api/team/' + this.$route.params.id)
				.then(({data}) => {					
					this.id = data.id;
					this.image = data.image_ref;
					this.name = data.name;
					this.players = data.players;
					
					this.getResultMatches();
					this.getFinishedMatches();
				});
			
			$(window).on('scroll load', () => {
				if (window.isVisible($('.match-loading'))) {
					this.getResultMatches()
				}
			});
		},
		
		methods: {
			getResultMatches() {
				if (this.id === 0 || this.activeLoading) return;
				
				this.activeLoading = true;
				
				this.axios.get('/api/events?team_id=' + this.id + '&group=tournament&order=startdate&status=finished&limit=10&page=' + this.page)
					.then(({data}) => {
						this.activeLoading = false;
						if (this.loading) {
							if (Object.keys(data).length < 10) {
								this.loading = false;
								this.resultsMatches.push(data);
								this.page++;
								return false;
							}
							this.resultsMatches.push(data);
							this.page++;
						}
					});
			},
			getFinishedMatches() {
				this.axios.get('/api/events?team_id=' + this.id + '&status=notstarted')
					.then(({data}) => {
						this.finishedMatches = data;
					});
			}
		}
	}
</script>

<style scoped>

</style>